import { useIntl } from "react-intl";

import type { FindFlightOffersFlightStopV3 } from "@/types/codegen";
import { parseDuration } from "@/utils/duration";

type Props = {
  stops?: FindFlightOffersFlightStopV3[] | null;
  firstStopCity: string;
};

export const StopsLabel = ({ stops, firstStopCity }: Props) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col items-start">
      <div className="flex justify-between rounded-xl bg-surface-background px-2 py-1 text-sm font-medium text-text-primary">
        {stops && stops.length > 1 ? (
          <div>
            {stops.length}{" "}
            {intl.formatMessage({
              defaultMessage: "Stops",
              description: "flights.stops",
            })}
          </div>
        ) : stops && stops.length === 1 ? (
          <div>
            {stops[0].stopTime
              ? `${intl.formatMessage({ defaultMessage: "{hours}h {minutes}m", description: "durationValue" }, parseDuration(stops[0].stopTime))} `
              : null}
            {intl.formatMessage(
              {
                defaultMessage: "stop in {cityName}",
                description: "flights.stopInCity",
              },
              { cityName: firstStopCity },
            )}
          </div>
        ) : (
          <div>
            {intl.formatMessage({
              defaultMessage: "Direct flight",
              description: "flights.directFlight",
            })}
          </div>
        )}
      </div>
    </div>
  );
};
